export default {
  capabilities: {
    selectable: false
  },
  dragging: false
};
